import React, { useEffect, useState } from 'react';
import { editMissionary, insertMissionary } from '../../supabase/supabase';
import { Button, Form, Modal } from 'react-bootstrap';
import { Missionary } from '../../supabase/types';

export default function MissionaryForm({
    show,
    handleClose,
    missionary,
    isEdit = false
}: {
    show: boolean;
    handleClose: (email?: string) => void;
    missionary?: Missionary;
    isEdit?: boolean;
}) {
    const [missionaryEmail, setMissionaryEmail] = useState(missionary?.email || '');
    const [missionaryName, setMissionaryName] = useState(missionary?.name || '');
    const [startDate, setStartDate] = useState(missionary?.start_date || '');
    const [mission, setMission] = useState(missionary?.assigned_mission || '');

    console.log(missionary);

    useEffect(() => {
        if (isEdit) {
            setMissionaryEmail(missionary?.email || '');
            setMissionaryName(missionary?.name || '');
            setStartDate(missionary?.start_date || '');
            setMission(missionary?.assigned_mission || '');
        }
    }, [isEdit, missionary]);

    const handleSave = async () => {
        if (isEdit) {
            const res = await editMissionary({
                email: missionaryEmail,
                name: missionaryName,
                start_date: startDate,
                assigned_mission: mission,
                unique_id: missionary?.unique_id
            });
        } else {
            const res = await insertMissionary({
                email: missionaryEmail,
                name: missionaryName,
                start_date: startDate,
                assigned_mission: mission
            });
        }

        handleClose(missionaryEmail);
    };

    return (
        <Modal show={show} onHide={() => handleClose()} className="modern-modal">
            <Modal.Header closeButton className="modal-header">
                <Modal.Title className="modal-title">
                    {isEdit ? 'Edit Missionary' : 'Add New Missionary'}
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="modal-body">
                <Form className="modern-form">
                    <div className="form-group">
                        <Form.Label htmlFor="missionaryEmail" className="form-label">
                            Email Address
                        </Form.Label>
                        <Form.Control
                            type="email"
                            id="missionaryEmail"
                            value={missionaryEmail}
                            onChange={(e) => setMissionaryEmail(e.target.value)}
                            required
                            className="modern-input"
                            placeholder="missionary@example.com"
                        />
                    </div>
                    
                    <div className="form-group">
                        <Form.Label htmlFor="missionaryName" className="form-label">
                            Full Name
                        </Form.Label>
                        <Form.Control
                            type="text"
                            id="missionaryName"
                            value={missionaryName}
                            onChange={(e) => setMissionaryName(e.target.value)}
                            required
                            className="modern-input"
                            placeholder="Elder John Smith"
                        />
                    </div>
                    
                    <div className="form-group">
                        <Form.Label htmlFor="startDate" className="form-label">
                            Mission Start Date
                        </Form.Label>
                        <Form.Control
                            type="date"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            required
                            className="modern-input"
                        />
                    </div>
                    
                    <div className="form-group">
                        <Form.Label htmlFor="mission" className="form-label">
                            Assigned Mission
                        </Form.Label>
                        <Form.Control
                            type="text"
                            id="mission"
                            value={mission}
                            onChange={(e) => setMission(e.target.value)}
                            required
                            className="modern-input"
                            placeholder="Brazil São Paulo Mission"
                        />
                    </div>
                </Form>
            </Modal.Body>
            
            <Modal.Footer className="modal-footer">
                <Button variant="outline-secondary" onClick={() => handleClose()} className="cancel-btn">
                    Cancel
                </Button>
                <Button onClick={handleSave} className="save-btn">
                    {isEdit ? 'Update' : 'Create'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
